import { ButtonProps, IconButton, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
import { Flex } from "~/components/Flex";

type SelectionRowHeaderProps = {
  selectionIndex: number;
  showRemoveSelectionButton: boolean;
  onRemove: ButtonProps["onClick"];
  title: string;
};

export const ConditionBuilderSelectionRowHeader = ({
  selectionIndex,
  showRemoveSelectionButton,
  onRemove,
  title,
}: SelectionRowHeaderProps) => {
  return (
    <Flex alignItems="center" justifyContent="space-between">
      <Typography fontWeight={700}>
        {title} SELECTION {selectionIndex + 1}
      </Typography>
      {showRemoveSelectionButton && (
        <IconButton onClick={onRemove}>
          <Close />
        </IconButton>
      )}
    </Flex>
  );
};
